/* ------------------------------------------------------------------------
Copyright (c) 2016, VoiceVibes, Inc

VoiceVibes, Inc - PROPRIETARY/CONFIDENTIAL
All contents of this file are proprietary and confidential. No part of
any of the contents of this file may be disclosed in any manner to
a third party without the prior written consent of VoiceVibes, Inc.
Unauthorized copying of this file, via any medium is strictly prohibited.
----------------------------------------------------------------------------- */

<template>
  <div
    v-if="results && results.scores"
    class="score-container svg-container"
    tabindex="-1"
  >
    <svg
      viewBox="0 0 300 180"
      class="gauge"
    >
      <defs>
        <radialGradient
          :id="'rLow-' + metric"
          cx="150"
          cy="160"
          r="110"
          gradientUnits="userSpaceOnUse"
        >
          <stop
            class="gauge-low"
            stop-opacity="0"
            offset="0%"
          />
          <stop
            class="gauge-low"
            offset="0%"
          />
        </radialGradient>
        <radialGradient
          :id="'rIdeal-' + metric"
          cx="150"
          cy="160"
          r="110"
          gradientUnits="userSpaceOnUse"
        >
          <stop
            class="gauge-ideal"
            stop-opacity="0"
            offset="0%"
          />
          <stop
            class="gauge-ideal"
            offset="0%"
          />
        </radialGradient>
        <radialGradient
          :id="'rHigh-' + metric"
          cx="150"
          cy="160"
          r="110"
          gradientUnits="userSpaceOnUse"
        >
          <stop
            class="gauge-high"
            stop-opacity="0"
            offset="0%"
          />
          <stop
            class="gauge-high"
            offset="0%"
          />
        </radialGradient>
        <path
          :id="'gaugeLow-' + metric"
          :d="lowPath"
        />
        <path
          :id="'gaugeIdeal-' + metric"
          :d="idealPath"
        />
        <path
          :id="'gaugeHigh-' + metric"
          :d="highPath"
        />
        <path
          :id="'gaugeText-' + metric"
          :d="textPath"
        />
        <path
          :id="'arrow-' + metric"
          :d="arrowPath"
        />
      </defs>

      <g>
        <use
          :xlink:href="'#gaugeLow-' + metric"
          class="gauge-zone"
          :fill="'url(#rLow-' + metric + ')'"
        />
        <use
          :xlink:href="'#gaugeIdeal-' + metric"
          class="gauge-zone"
          :fill="'url(#rIdeal-' + metric + ')'"
        />
        <use
          :xlink:href="'#gaugeHigh-' + metric"
          class="gauge-zone"
          :fill="'url(#rHigh-' + metric + ')'"
        />
      </g>
      <g>
        <text
          class="gauge-text gauge-low"
          text-anchor="middle"
        >
          <textPath
            :xlink:href="'#gaugeText-' + metric"
            startOffset="16%"
          >
            {{ config.lowText }}
          </textPath>
        </text>
        <text
          class="gauge-text gauge-ideal"
          text-anchor="middle"
        >
          <textPath
            :xlink:href="'#gaugeText-' + metric"
            startOffset="50%"
          >
            {{ config.idealText }}
          </textPath>
        </text>
        <text
          class="gauge-text gauge-high"
          text-anchor="middle"
        >
          <textPath
            :xlink:href="'#gaugeText-' + metric"
            startOffset="84%"
          >
            {{ config.highText }}
          </textPath>
        </text>
      </g>
      <g>
        <use
          :xlink:href="'#arrow-' + metric"
          class="gauge-arrow"
          :transform="'translate(150,160) rotate(' + angle + ',0,0)'"
        />
      </g>
    </svg>
  </div>
</template>

<script>
import ChartHelper from '../utils/ChartHelper';

export default {
  mixins: [ChartHelper],
  props: ['recording', 'wavesurfer', 'metric', 'speakerNum', 'tooltipId'],
  data() {
    return {
      centerX: 150,
      centerY: 160,
      innerRadius: 70,
      outerRadius: 130,
      arrowWidth: 30,
    };
  },
  computed: {
    arrowLength() {
      return .5 * this.innerRadius + .5 * this.outerRadius;
    },
    lowPath() {
      return this._arcPath(this.centerX, this.centerY, this.innerRadius, this.outerRadius, 180, 120);
    },
    idealPath() {
      return this._arcPath(this.centerX, this.centerY, this.innerRadius, this.outerRadius, 120, 60);
    },
    highPath() {
      return this._arcPath(this.centerX, this.centerY, this.innerRadius, this.outerRadius, 60, 0);
    },
    textPath() {
      return `
              M ${this.centerX - this.outerRadius - 5} ${this.centerY}
              A ${this.outerRadius + 5} ${this.outerRadius + 5} 0 0 1 ${this.centerX + this.outerRadius + 5} ${this.centerY}`;
    },
    angle() {
      if (this.score <= this.config.min) {
        return 0;
      } else if (this.score < this.config.idealMin) {
        return (this.score - this.config.min) / (this.config.idealMin - this.config.min) * 60;
      } else if (this.score < this.config.idealMax) {
        return 60 + (this.score - this.config.idealMin) / (this.config.idealMax - this.config.idealMin) * 60;
      } else if (this.score < this.config.max) {
        return 120 + (this.score - this.config.idealMax) / (this.config.max - this.config.idealMax) * 60;
      }
      return 180;
    },
    arrowPath() {
      return `
          M 0 ${this.arrowWidth / 2}
          L -${this.arrowLength} 2
          A 1 1 0 0 1 -${this.arrowLength} -2
          L 0 -${this.arrowWidth / 2}
          A 1 1 0 0 1 0 ${this.arrowWidth / 2}
          z
          `;
    },
  },
  mounted() {
    this._addTooltip(this.tooltipId, this.recording, this.metric);
  },
};
</script>
